<template>
    <select :value="modelValue" class="form-select border border-gray-500 rounded-full w-96 focus:border-selected" @change="$emit('update:modelValue', $event.target.value)" ref="input">
        <option value="">N/A</option>
        <option v-for="(option, key) in options" :key="key" :value="option" :disabled="!canSelectOptions(option)" class="disabled:text-gray-200">{{ option }}</option>
    </select>
</template>
<script>
    export default {
        emits: ['update:modelValue'],
        props: {
            modelValue: String,
            options: Object,
            optionsFree: Object,
            placeholder: String,
        },
        methods: {
            canSelectOptions(option) {
                return this.optionsFree.some(el => el == option);
            }
        }
    }
</script>
<style scoped>
    /* Hide scrollbar for Chrome, Safari and Opera */
    .no-scroll-bar::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    .no-scroll-bar {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }    
</style>

